import { type Editor } from '@tiptap/react';
import { useTranslation } from 'next-i18next';
import { useViewport } from '@/hooks';
import { HighlighterIcon } from '@/icons/components/Highlighter';
import { Tooltip } from '@/ui_v3';
import { IconButton } from '@/ui_v3/components/button';
import { cn } from '@/utils';
import { useColorHighlight } from './useColorHighlight';
export const HighlightButton = ({
  editor,
  className,
  onClick
}: {
  editor: Editor | null;
  className?: string;
  onClick?: () => void;
}) => {
  const {
    isActive
  } = useColorHighlight({
    editor
  });
  const {
    t
  } = useTranslation(['build']);
  const {
    isMobile
  } = useViewport();
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="HighlightButton" data-sentry-source-file="HighlightButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="HighlightButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="HighlightButton.tsx">
          <IconButton size="xs" variant="transparent" intent="neutral" className={cn(className, isActive && 'bg-gray-200')} onMouseDown={e => {
          e.preventDefault(); // Prevent focus loss
        }} onClick={e => {
          e.stopPropagation();
          onClick?.();
        }} data-sentry-element="IconButton" data-sentry-source-file="HighlightButton.tsx">
            <HighlighterIcon fill={isActive ? '#6758FF' : '#5D5E69'} size="xs" data-sentry-element="HighlighterIcon" data-sentry-source-file="HighlightButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="HighlightButton.tsx">{t('build.textEditor.highlight')}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};